var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 656,
    viewBox: "0 0 656 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2229 215.071C93.7165 348.42 276.153 518.228 399.713 557.684C482.629 584.158 605.949 531.937 557.151 483.126L480.102 406.04C468.387 394.316 449.4 395.68 437.953 407.124L393.709 451.354C298.527 399.495 258.591 358.67 206.299 264.058L250.611 219.783C262.075 208.316 263.374 189.358 251.65 177.634L174.569 100.551C131.43 57.4115 84.7632 164.649 87.2229 215.071Z",
    fill: "#333ADB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.223 215.071L206.299 264.058L250.611 219.782C262.075 208.315 263.374 189.357 251.65 177.633L174.569 100.55C131.43 57.4108 84.7633 164.649 87.223 215.071Z",
    fill: "#333ADB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.713 557.683C482.63 584.157 605.95 531.936 557.151 483.125L480.102 406.039C468.387 394.315 449.401 395.679 437.953 407.123L393.709 451.353L399.713 557.683Z",
    fill: "#333ADB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 655.359,
    height: 655.359,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3fee24d13a01fba2816dbcfe4b0c2b2b.svg";
export { ForwardRef as ReactComponent };